module.exports = __webpack_public_path__ + "static/img/sms-new.c803576.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/sms-new.png
// module id = ATo1
// module chunks = 58